import { useEffect, useState } from 'react';

export default function PageLoader() {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 1200);
    const hideTimer = setTimeout(() => setVisible(false), 1800);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9998] flex items-center justify-center bg-background-50 transition-opacity duration-600 ease-out ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-6">
        <div className="relative w-20 h-20 flex items-center justify-center">
          <div className="absolute inset-0 rounded-full border-2 border-primary-200 animate-loader-ring"></div>
          <div className="absolute inset-2 rounded-full border-2 border-accent-300 animate-loader-ring-reverse"></div>
          <i className="ri-plane-line text-3xl text-primary-500 animate-loader-plane"></i>
        </div>

        <div className="flex flex-col items-center gap-2">
          <span className="font-heading text-xl font-bold">
            <span className="text-primary-500">LUCKY</span>{' '}
            <span className="text-accent-500">HOLIDAYS</span>
          </span>
          <div className="flex gap-1">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="w-2 h-2 rounded-full bg-primary-500 animate-loader-dot"
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}